import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';

export const CONTRACTS_PATH = '/contracts';

export const useContractsUrl = () => useEntityUrl({ baseLink: CONTRACTS_PATH });

export const useContractsId = () => useParams<Dictionary<string>>().id!;
